<!-- 上报及办理量对比 -->
<template>
    <div class='wrapper box_v'>
        <div class="title">每月待处理和已处理事件统计</div>
        <div class='box_f1' id="echart_submit_solve" style="width:100%;height:100%"></div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import echarts from 'echarts'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            mon:[],
            submitList:[],
            solveList:[],
            handelTag:''
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.monitor_eventFinishMonth).then(res=>{
                this.mon = res.rows.map(item=>item.creatTime)
                //let handelData = res.rows.map(item=>item.handleCount)
                //this.handelData = this.$util.handleNumber(handelData).numArr
                //this.handelTag = this.$util.handleNumber(handelData).tag
                this.submitList = res.rows.map(item=>{
                    return {
                        value: item.totalCount,
                        symbolOffset: [0, -8],
                        symbol: `image://${require("../../../../assets/images/monitorpy/bar_blue.png")}`
                    }
                })
                this.solveList = res.rows.map(item=>{
                    return {
                        value: item.finishedCount,
                        symbolOffset: [0, -8],
                        symbol: `image://${require("../../../../assets/images/monitorpy/bar_green.png")}`
                    }
                })

                this.$nextTick(()=>{
                    this.initEcharts()
                })
            })
        },
        initEcharts(){
            
            let echart = echarts.init(document.getElementById('echart_submit_solve'));

            let option = {
                color: ['#0090FF', '#33DABD'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    // containLabel: true,
                    left: '10%',
                    top: "9%",
                    bottom: "10%",
                },
                xAxis: {
                    data: this.mon,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        color: '#999999',
                        interval: 0
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#999999',
                        }
                    }
                },
                yAxis: {
                    splitLine: { show: false },
                    axisLine: {
                        lineStyle: {
                            color: '#999999',
                        }
                    },
                    axisLabel: {
                        color: '#999999',
                        //interval: 0
                    },
                },
                legend: {
                    data: ['待处理','已处理'],
                    icon:"roundRect",
                    textStyle:{
                        color:'#fff'
                    }
                },
                series: [{
                    type: 'pictorialBar',
                    id:'submit',
                    name: '待处理',
                    barGap:'20%',
                    barwidth:'30%',
                    symbolSize: ['80%', '80%'],
                    symbolPosition: 'start',
                    //symbolOffset: ['-50%', 0],
                    //z: 10,
                    data: this.submitList
                },
                {
                    type: 'pictorialBar',
                    name: '已处理',
                    id:'solve',
                     barGap:'20%',
                    barwidth:'30%',
                    symbolSize: ['80%', '80%'],
                    symbolPosition: 'start',
                    // symbolOffset: ['50%', 0],
                    //z: 10,
                    data: this.solveList
                }]
            };
            

            echart.setOption(option)
           
        }
        
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper{
    height:100%;
    width:100%;
    background-image: url('../../../../assets/images/monitorpy/bottom.png');
    background-size: 100% 100%;
}
.title{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin-left: 40px;
    margin-top: 20px
}
</style>